import type React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

import type { CallState } from "../../types";

import { StateInfo } from "./StateInfo";

interface Props {
  readonly onCallAgain: () => void;
  readonly onEndCall: () => void;
  readonly callState: CallState;
  readonly error?: string | null;
}

export const CallingStateModal: React.FC<Props> = ({ onCallAgain, onEndCall, callState, error = null }) => {
  const contentStates = ["CONNECTION_FAILED", "CALLEE_REJECTED", "CALLEE_DISCONNECTED"];
  const { t } = useTranslation();

  if (contentStates.includes(callState)) {
    return (
      <MUIUnifiedModal
        open={contentStates.includes(callState)}
        onClose={() => undefined}
        showCloseButton={false}
        width="355px"
      >
        <ModalBackground data-testid="calling-state-modal">
          <StateInfo callState={callState} error={error} />
          <Stack alignItems="center" spacing={1} pb={2}>
            <BaseButton data-testid="call-again-button" onClick={onCallAgain} text={t("buttons.call_again")} />
            <BaseButton variant="text" data-testid="exit-call-button" onClick={onEndCall} text={t("buttons.exit")} />
          </Stack>
        </ModalBackground>
      </MUIUnifiedModal>
    );
  }

  return null;
};

const ModalBackground = styled.div`
  background: linear-gradient(to top, #fff 81%, ${props => props.theme.colors.pastels.red} 19%);
  min-height: 291px;
  display: flex;
  flex-direction: column;
`;
